import { action } from 'mobx';
import { observer } from 'mobx-react';
import React from 'react';
import { toast, ToastContainer } from 'react-toastify';

import { WithDbId } from '../../../../../adl-gen/common/db';
import { Skill } from '../../../../../adl-gen/totalinteraction/futurefit/db';
import { Route } from '../../../../../routing/app-routes';
import { SkillListAndData, SkillStore, SkillTrainingOfferingChange } from '../../../../stores';
import { FormMode, toastOptions } from '../../../common/form';

// tslint:disable-next-line: no-import-side-effect ordered-imports
import '../../../widgets/toast/toastify.css';
import { SkillEditor } from '../../editors/skill-editor/skill-editor';

interface SkillFormProps {
  item?: WithDbId<Skill>;
  store: SkillStore;
  data: SkillListAndData;
  mode?: FormMode;
  onCancel(): void;
  navigateTo: (route: Route) => void;
}

@observer
export class SkillForm extends React.Component<SkillFormProps> {
  onCreate = async (item: Skill): Promise<void> => {
    const { onCancel, store } = this.props;
    if (!store.isSuperUser) {
      throw new Error('cannot create skill - not authorized');
    } else {
      const toastId = toast.loading('Please wait...', { ...toastOptions, autoClose: 3000 });
      try {
        await store.create(item);

        toast.dismiss(toastId);
        toast.success(`Skill ${item.name.value.en} created.`, {
          ...toastOptions,
          onClose: onCancel,
          autoClose: 3000
        });
      } catch (e) {
        toast.dismiss(toastId);
        toast.error(`Skill ${item.name.value.en} create failed: ${(e as Error).message}`, {
          ...toastOptions,
          onClose: onCancel
        });
      }
    }
  };

  onUpdate = async (item: WithDbId<Skill>, trainingOfferingUpdates: SkillTrainingOfferingChange[]): Promise<void> => {
    const { onCancel, store } = this.props;
    const toastId = toast.loading('Please wait...', { ...toastOptions, autoClose: 3000 });
    try {
      /// TODO: Defer refresh to ensure confirmation dialog pops up OBSOLETE
      await store.update(item);
      await store.updateSkillTrainingOfferings(trainingOfferingUpdates);

      toast.dismiss(toastId);
      toast.success(`Skill ${item.value.name.value.en} updated.`, {
        ...toastOptions,
        onClose: onCancel,
        autoClose: 3000
      });
    } catch (e) {
      toast.dismiss(toastId);
      toast.error(`Skill ${item.value.name.value.en} update failed: ${(e as Error).message}`, {
        ...toastOptions,
        onClose: onCancel
      });
    }
  };

  @action
  onCancel = () => {
    this.props.onCancel();
  };

  renderContent = () => {
    const {
      data,
      item: skill,
      mode,
      navigateTo,
      store
    } = this.props;
    if (mode === 'update' && skill) {
      return (
        <SkillEditor
          item={skill}
          data={data}
          store={store}
          onCancel={this.onCancel}
          onCreate={this.onCreate}
          onUpdate={this.onUpdate}
          applicationRole={store.isSuperUser ? 'super' : 'client-admin'}
          navigateTo={navigateTo}
        />
      );
      /// TODO: Delete
    } else {
      return (
        <SkillEditor
          data={data}
          store={store}
          onCancel={this.onCancel}
          onCreate={this.onCreate}
          onUpdate={this.onUpdate}
          applicationRole={store.isSuperUser ? 'super' : 'client-admin'}
          navigateTo={navigateTo}
        />
      );
    }
  };

  render() {
    return (
      <React.Fragment>
        {this.renderContent()}
        <ToastContainer newestOnTop />
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/admin/ui/components/forms/skill-form/skill-form.tsx